import React from 'react';
import CardFile from '../CardFile/CardFile';
import './styles.css';
import { File } from '../../../../../../../types/File';
import videoImage from '../../../../../../../utils/app/assets/images/Video.png';
import usePTTMessageStore, {
    PTTMessage,
} from '../../../../../pttDispatcher/api/usePttMessageStore';
import { isPTTMessage } from '../../helpers/consts/consts';
import { useFilesStore } from '../../../../../../../store/devices/FilesDevicesFromDB';
import { useOpenMoreDetails } from '../../../../../../../store/devices/useShowMoreDetails';
import { useSelectedFile } from '../../../../../../../store/devices/getSelectedFile';
import MoreDetails from '../../../../../../../components/modals/moreDetails/MoreDetalies';
import { FormInstance, List, Pagination, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface ArchiveResultsProps {
    selectedFiles: Record<string, boolean>;
    isSearching: boolean;
    contentType: 'files' | 'radiochat';
    onFileClick: (file: File | PTTMessage) => void;
    onCheckboxChange: (fileId: string, checked: boolean) => void;
    pagination: {
        current: number;
        pageSize: number;
        total: number;
    };
    onPageChange: (page: number, pageSize: number) => void;
}

const ArchiveResults: React.FC<ArchiveResultsProps> = ({
    // results,
    selectedFiles,
    isSearching,
    contentType,
    onFileClick,
    onCheckboxChange,
    onPageChange,
    pagination,
}) => {
    const { fetchFiles, filesArchive } = useFilesStore();
    const { messagesArchive } = usePTTMessageStore();
    const { openMoreDetails, setOpenMoreDetails } = useOpenMoreDetails();
    const { selectedFile, setSelectedFile } = useSelectedFile();

    const onCloseMoreDetails = () => {
        setOpenMoreDetails(false);
    };

    const results = contentType == 'files' ? filesArchive : messagesArchive;

    return (
        <div className="archive-results">
            {/* Заголовок с пагинацией - всегда видим */}
            <div className="archive-results-title">
                <div>
                    Результат поиска
                    <span className={'headline small'} style={{ color: 'var(--gray-02)' }}>
                        {' '}
                        ({results?.length || 0})
                    </span>
                </div>

                <Pagination
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    onChange={onPageChange}
                    onShowSizeChange={onPageChange}
                    showSizeChanger
                    // showQuickJumper
                    showTotal={(total, range) => `${range[0]}-${range[1]} из ${total}`}
                    pageSizeOptions={[20, 50, 100, 200]}
                    disabled={pagination.total === 0}
                />
            </div>

            {isSearching ? (
                <div className="player-loading-archive">
                    <Spin
                        tip="Загрузка файлов..."
                        indicator={<LoadingOutlined className={'spin-icon-archive'} spin />}
                    />
                </div>
            ) : results !== undefined && results.length > 0 ? (
                <div className="results-grid">
                    <List
                        grid={{
                            gutter: 12,
                            lg: 1,
                            xl: 2,
                            xxl: 3,
                            md: 1,
                            xs: 1,
                            sm: 1,
                        }}
                        //@ts-ignore
                        dataSource={results}
                        renderItem={(item: File | PTTMessage) => (
                            <List.Item>
                                <CardFile
                                    key={isPTTMessage(item) ? item.uid : item.UID}
                                    item={item}
                                    isSelected={
                                        isPTTMessage(item)
                                            ? selectedFiles[item.uid!]
                                            : !!selectedFiles[item.UID]
                                    }
                                    onCheckboxChange={onCheckboxChange}
                                    onClick={onFileClick}
                                    contentType={contentType}
                                />
                            </List.Item>
                        )}
                    />
                </div>
            ) : (
                <div className="archive-img-container">
                    <div className="archive-img-content">
                        <img src={videoImage} alt="Изображение не найдено" />
                        <span className="title large archive-img-text">
                            Файлы по заданным фильтрам не найдены
                        </span>
                    </div>
                </div>
            )}

            {/* Модальное окно */}
            {openMoreDetails && selectedFile && (
                <MoreDetails
                    onOk={onCloseMoreDetails}
                    open={openMoreDetails}
                    onCancel={onCloseMoreDetails}
                />
            )}
        </div>
    );
};

export default ArchiveResults;
